module.exports = __webpack_public_path__ + "img/human-1.63ef4118.svg";